<template>
    <div id="item-menu">
        <div class="header">
            Form Elemanları
            <span class="md-icon" @click="$emit('close')">close</span>
        </div>
        <div class="content">
            <div class="item"
                 v-for="item in items"
                 :key="item.text"
                 @dragstart="onDragStart(item)"
                 :draggable="!isDisabled(item.id)"
                 :class="{ disabled: isDisabled(item.id) }">
                <div class="item-image">
                    <span class="md-icon">{{ item.icon }}</span>
                </div>
                <div class="item-text">{{ item.text }}</div>
            </div>
            <div class="title">TEMEL ELEMANLAR</div>
            <div class="item"
                 v-for="item in keyAreas"
                 :key="item.text"
                 @dragstart="onDragStart(item)"
                 :draggable="!isDisabled(item.id)"
                 :class="{ disabled: isDisabled(item.id) }">
                <div class="item-image">
                    <span class="md-icon">{{ item.icon }}</span>
                </div>
                <div class="item-text">{{ item.text }}</div>
            </div>
            <div class="title">ANKET ELEMANLARI</div>
            <div class="item"
                 v-for="item in surveyElements"
                 :key="item.text"
                 @dragstart="onDragStart(item)"
                 :draggable="!isDisabled(item.id)"
                 :class="{ disabled: isDisabled(item.id) }">
                <div class="item-image">
                    <span class="md-icon">{{ item.icon }}</span>
                </div>
                <div class="item-text">{{ item.text }}</div>
            </div>
            <div class="title">SAYFA ELEMANLARI</div>
            <div class="item"
                 v-for="item in pageElements"
                 :key="item.text"
                 @dragstart="onDragStart(item)"
                 :draggable="!isDisabled(item.id)"
                 :class="{ disabled: isDisabled(item.id) }">
                <div class="item-image">
                    <span class="md-icon">{{ item.icon }}</span>
                </div>
                <div class="item-text">{{ item.text }}</div>
            </div>
            <div style="margin-top:100px"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ItemMenu",
    data() {
        return {
            items: [
                { id: "title", icon: "title", text: "Başlık" },
                { id: "fullName", icon: "person", text: "Tam Ad" },
                { id: "email", icon: "mail", text: "E-posta" },
                { id: "address", icon: "pin_drop", text: "Adres" },
                { id: "phone", icon: "add_call", text: "Telefon" },
                { id: "datePicker", icon: "date_range", text: "Tarih Seçiçi" },
                { id: "meeting", icon: "access_time", text: "Randevu" },
                { id: "signature", icon: "edit", text: "İmza" },
                { id: "listOfProducts", icon: "production_quantity_limits", text: "Ürün Listesi" },
            ],
            keyAreas: [
                { id: "shortText", icon: "edit_note", text: "Kısa Metin" },
                { id: "longText", icon: "draw", text: "Uzun Metin" },
                { id: "paragraph", icon: "text_increase", text: "Paragraf" },
                { id: "dropDownList", icon: "low_priority", text: "Açılır Liste" },
                { id: "singleChoice", icon: "radio_button_checked", text: "Tekli Seçim" },
                { id: "multipleSelection", icon: "checklist", text: "Çoklu Seçim" },
                { id: "number", icon: "filter_7", text: "Sayı" },
                { id: "image", icon: "image", text: "Görsel" },
                { id: "fileUpload", icon: "drive_folder_upload", text: "Dosya Yükleme" },
                { id: "hour", icon: "timer", text: "Saat" },
                { id: "spinner", icon: "join_left", text: "Değer Değiştirici" },
                { id: "send", icon: "send", text: "Gönder" },
            ],
            surveyElements: [
                { id: "dataTable", icon: "calculate", text: "Veri Tablosu" },
                { id: "starRating", icon: "star", text: "Yıldız Değerlendirme" },
                { id: "ratingScale", icon: "bar_chart", text: "Değerlendirme Ölçeği" },
            ],
            pageElements: [
                { id: "separationElement", icon: "safety_divider", text: "Ayırma Elemanı" },
                { id: "collapseSection", icon: "expand", text: "Bölüm Daraltma" },
                { id: "pageBreak", icon: "insert_page_break", text: "Sayfa Sonu" },
            ],
            draggedItem: null,
        };
    },
    methods: {
        onDragStart(item) {
            if (this.isDisabled(item.id)) {
                this.$message.warning(`${item.text} Elemanı Yapım Aşamasındadır.`);
            } else {
                this.draggedItem = item;
                event.dataTransfer.setData("item", JSON.stringify(item));
            }
        },
        isDisabled(itemId) {
            const disabledItems = [
                "meeting",
                "signature",
                "listOfProducts",
                "paragraph",
                "image",
                "dataTable",
                "collapseSection",
                "pageBreak",
                "singleChoice",
                "multipleSelection",
            ];
            return disabledItems.includes(itemId);
        },
    }
};
</script>

<style scoped>
#item-menu {
    width: 260px;
    background-color: #fff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    font-family: 'Roboto', sans-serif;

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px;
        background-color: #33384a;
        color: #ffffff;
        gap: 100px;

        .md-icon {
            font-size: 1.5rem;
            cursor: pointer;
        }
    }

    .content {
        max-height: 100%;
        overflow-y: auto;

        .title {
            padding: 10px 15px;
            background-color: #f1f1f1;
            color: #333;
            font-weight: bold;
            font-size: 0.9rem;
        }

        .item {
            display: flex;
            align-items: center;
            padding: 10px 15px;
            border-bottom: 1px solid #eee;
            transition: background-color 0.3s;
            cursor: pointer;

            &:hover {
                background-color: #f9f9f9;
            }

            &.disabled {
                opacity: 0.5;
                pointer-events: none;
            }

            .item-image {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 40px;
                height: 40px;
                font-size: 1.5rem;
                color: #33384a;
                margin-right: 15px;
                background: #bcbcbd;
                border-radius: 10px;
            }

            .item-text {
                flex: 1;
                font-size: 1rem;
                color: #333;
            }
        }
    }
}
</style>
